import { signIn, SignInAuthorizationParams } from 'next-auth/react';
import { useCallback } from 'react';

type SignInProps = {
  provider?: string;
  callbackUrl?: string;
  authParams?: SignInAuthorizationParams;
};
function useSignIn() {
  const signin = useCallback(async (props?: SignInProps) => {
    const currentUrl = window.location.href;
    if (props) {
      await signIn(
        props.provider ? props.provider : 'azure-ad-b2c',
        {
          callbackUrl: props.callbackUrl
            ? props.callbackUrl
            : currentUrl
            ? currentUrl
            : '/',
        },
        props.authParams,
      );
    } else {
      await signIn('azure-ad-b2c', {
        callbackUrl: currentUrl ? currentUrl : '/',
      });
    }
  }, []);

  return {
    signIn: signin,
  };
}

export default useSignIn;
